import styled from "styled-components";
import { Fragment } from "react";

import { ReactComponent as DescriptionIcon } from "../../../shared/resources/icons/description.svg";
import { ReactComponent as FolderClosed } from "./../../../shared/resources/icons/folder.svg";
import { ReactComponent as FileIcon } from "./../../../shared/resources/icons/file-regular.svg";

export default function WorkOrderSideMenu({ files }) {
  // console.log(files);
  return (
    <>
      <SideNav className="mt-2">
        <SideNavListItem>
          <SideNavLink href="#">
            <DescriptionIcon />
            Description
          </SideNavLink>
        </SideNavListItem>
        {files && (
          <SideNavListItem>
            <SideNavLink>
              <FolderClosed />
              Fichiers
            </SideNavLink>

            <SideNav>
              {files.map((file) => (
                <Fragment key={file.id}>
                  <SideNavListItem>
                    <SideNavLink>
                      <FileIcon />
                      <FileName title={file.name}>{file.name}</FileName>
                    </SideNavLink>
                  </SideNavListItem>
                </Fragment>
              ))}
            </SideNav>
          </SideNavListItem>
        )}
      </SideNav>
    </>
  );
}

const SideNav = styled.ul`
  list-style: none;
  padding: 0;
`;
const SideNavListItem = styled.li`
  padding: 0.5rem 1.5rem;
  margin: 0;
`;
const SideNavLink = styled.a`
  font-size: 1.1rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  color: "inherit";
  gap: 0.5rem;
  cursor: pointer;
  & svg {
    height: 1.4rem;
  }
`;

const FileName = styled.span`
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
`;
